import React from 'react';
import TextField from '@mui/material/TextField';

export default function TextFieldInput({ className, label, ...rest }) {
  return (
    <TextField className={className} {...rest} label={label} variant="filled" />
  );
}
